<!--
 * @Author: LHH
 * @Date: 2019-08-13 14:08:49
 -->
<template>
  <ul class="imagetext-list">
    <li class="imagetext-item" v-for="(item, index) in list" :key="index">
      <article>
        <h2 class="title">{{ item.title }}</h2>
        <p class="content">{{ item.content }}</p>
      </article>
      <div class="pic">
        <img :src="item.pic" alt />
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'ImgTextList',
  props: {
    list: Array // *数组格式：{title: String, content: String, pic: String}
  }
}
</script>

<style lang="less" scoped>
// 图文列表组件
.imagetext-list {
  height: auto;
  .imagetext-item {
    position: relative;
    padding: 65px;
    height: auto;
    text-align: left;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.14);
    border: 1px solid rgba(151, 151, 151, 0);
    background-color: #ffffff;
    display: flex;
    &:first-child {
      background-color: #edf1f5;
    }
    article {
      height: auto;
      color: #989b9e;
      flex-shrink: 0;

      .title {
        font-size: 38px;
        font-weight: bold;
        padding-bottom: 24px;
        height: auto;
      }
      .content {
        font-size: 28px;
      }
    }
    .pic {
      width: 100%;
      height: auto;

      img {
        display: block;
      }
    }
  }
  @media screen and (min-width: 720px) {
    .imagetext-item {
      display: flex;
      align-items: center;

      &:nth-child(2n + 0) {
        article {
          order: 1;
        }
        .pic {
          order: 0;

          img {
            float: left;
          }
        }
      }
      article {
        width: 532px;
        flex-shrink: 0;
      }
      .pic {
        overflow: hidden;

        img {
          width: 584px;
          float: right;
        }
      }
    }
  }
  @media screen and (min-width: 0px) and (max-width: 720px) {
    .imagetext-item {
      flex-direction: column;
      > * {
        width: 100%;
      }
      article {
        order: 1;

        .title {
          text-align: center;
          padding: 24px 0;
          font-size: 26PX;
        }
        .content {
          font-size: 22PX;
        }
      }
      .pic {
        order: 0;

        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
